module.exports = __webpack_public_path__ + "static/media/5sec-countdown.d2871776.mp3";